// Scroll to top on route change - fix for small devices
export default () => {
  window.scrollTo(0, 0)
}
